import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import { LanguageProvider } from '@/contexts/LanguageContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { Layout } from '@/components/Layout';
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { AssetsPage } from '@/pages/AssetsPage';
import { WorkOrdersPage } from '@/pages/WorkOrdersPage';
import { RepairVsReplacePage } from '@/pages/RepairVsReplacePage';
import { FaultReportPage } from '@/pages/FaultReportPage';
import { BOZPPage } from '@/pages/BOZPPage';
import { PredictiveMaintenancePage } from '@/pages/PredictiveMaintenancePage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import '@/App.css';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="assets" element={<AssetsPage />} />
        <Route path="work-orders" element={<WorkOrdersPage />} />
        <Route path="repair-vs-replace" element={<RepairVsReplacePage />} />
        <Route path="fault-report" element={<FaultReportPage />} />
        <Route path="bozp" element={<BOZPPage />} />
        <Route path="predictive" element={<PredictiveMaintenancePage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <LanguageProvider>
            <AppRoutes />
            <Toaster position="top-right" richColors />
          </LanguageProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
